<template>
  <div v-if="person">
    <div v-if="!preview">
      <p v-if="person.name" class="mb-0">{{person.name}}</p>
      <p v-if="person.address" class="mb-0">{{person.address}}</p>
      <p v-if="person.tel" class="mb-0"><a :href="'tel:'+person.tel">{{person.tel}}</a></p>
      <p v-if="person.url" class="mb-0"><a :href="person.url" target="_blank">{{person.url}}</a></p>
      <p v-if="person.email" class="mb-0"><a :href="'mailto:'+person.email">{{person.email}}</a></p>
      <p>
        <a v-if="person.instagram" target="_blank" rel="noreferrer" :href="person.instagram" class="contactIcon icon brands fa-instagram fa-lg"><span class="label">Instagram</span></a>
        <a v-if="person.facebook" target="_blank" rel="noreferrer" :href="person.facebook" class="contactIcon icon brands fa-facebook fa-lg"><span class="label">Instagram</span></a>
        <a v-if="person.youtube" target="_blank" rel="noreferrer" :href="person.youtube" class="contactIcon icon brands fa-youtube fa-lg"><span class="label">Youtube</span></a>
      </p>
    </div>
    <div v-else>
      <p v-if="person.name" class="mb-0">{{person.name}}</p>
      <ShortDescription v-if="person.vita" class="mb-0" :text="person.vita"/>
      <p v-if="person.url" class="mb-0"><a :href="person.url" target="_blank">{{person.url}}</a></p>
      <p>
        <a v-if="person.instagram" target="_blank" rel="noreferrer" :href="person.instagram" class="contactIcon icon brands fa-instagram fa-lg"><span class="label">Instagram</span></a>
        <a v-if="person.facebook" target="_blank" rel="noreferrer" :href="person.facebook" class="contactIcon icon brands fa-facebook fa-lg"><span class="label">Instagram</span></a>
        <a v-if="person.youtube" target="_blank" rel="noreferrer" :href="person.youtube" class="contactIcon icon brands fa-youtube fa-lg"><span class="label">Youtube</span></a>
      </p>
    </div>
  </div>

</template>

<script>

import ShortDescription from '@/components/ShortDescription.vue'
export default {
  name: 'RTReferentContact',
  components:{
    ShortDescription
  },
  props:{
    person:{
      type:Object
    },
    preview:{
      type:Boolean,
      default:false
    }
  },
  watch:{
  },
  data: function() {
    return {
    };
  },
  computed:{

  },
  methods:{
   
  },

  mounted(){
  },
};
</script>

<style scoped type='text/css'>
.contactIcon{
  padding-right: 0.5rem;
}
</style>